module.exports = __webpack_public_path__ + "static/4f3d5d4d5860a8f808a6832adc25c93ea7f33c6c14f952fea3724a4f17991dd7-3acfebc35d27504c45d9e3cccbf233d4.png";